import { Row } from "react-bootstrap";
import { FormControl } from "../../Forms/FormControl";
import { KpoBdoDropdown } from "../../Bdo/Kpo/KpoBdoDropdown";
import { useFormContext } from "react-hook-form";
import { useEffect } from "react";
import { HorizontalView } from "../../Abstractions/HorizontalView";
import { SaleWastesAdditionalForm } from "./SaleWastesAdditionalForm";
import { NumericControl } from "../../Forms/NumericControl";
import { Dropdown } from "../../Abstractions/Dropdown";
import { WasteFormType } from "../../../domain/WasteFormType";
import { ReadonlyControl } from "../../Forms/ReadonlyControl";
import { DomainSwitch } from "../../Abstractions/DomainSwitch";

export function BaseWasteForm({ parentName, waste, kpoItems, requireApplicableKpoItems, additionalWasteControls, includeExtendedSaleWastesData, showExtendedView }) {
  const GetFieldName = (name) => `${parentName}.${name}`;
  const { watch, setValue } = useFormContext();
  // const { fields: applicableKpoItems } = useFieldArray({ name: GetFieldName("applicableKpoItems") });
  const applicableKpoItems = watch(GetFieldName("applicableKpoItems"));
  const columnsSize = !showExtendedView ? [5, 3, 3] : [4, 2, 3, 2];

  useEffect(() => {
    if (applicableKpoItems?.length > 1) {
      setValue(GetFieldName("validateWasteMass"), true);
    } else {
      // replace([]);
      setValue(GetFieldName("validateWasteMass"), false);
    }
  }, [applicableKpoItems]);

  return <>
    <div className="my-2">
      <Row>
        <hr></hr>
        <HorizontalView columnsSize={columnsSize} className="d-flex gap-2 align-items-start">
          <FormControl name={GetFieldName("displayDescription")} label="Towar" readonly/>
          <Dropdown name={GetFieldName("wasteFormType")} items={WasteFormType} label="Forma" required={false}/>
          <NumericControl decimalPlaces={4} name={GetFieldName("wasteMass")} label="Masa odpadów [Mg]"/>
          {showExtendedView && waste?.externalWeighedWasteId &&
            <FormControl name={GetFieldName("externalWeighedWasteDescription")} label="Nr. ważenia" readonly required={false}/>}
            {/*// <ReadonlyControl label="Nr. ważenia">{waste.externalWeighedWasteId}</ReadonlyControl>}*/}
        </HorizontalView>
        {requireApplicableKpoItems && <div className="domain-control">
          <KpoBdoDropdown wasteCodeId={waste.wasteCodeBdoId} items={kpoItems} name={GetFieldName("applicableKpoItems")}/>
          {waste.applicableKpoItems?.length > 1 && <div className="mt-2">
            {applicableKpoItems?.map((x, idx) =>
              <div key={x.kpoId}>
                <FormControl name={GetFieldName(`applicableKpoItems[${idx}].wasteMass`)} label={`Masa (${x.description})`} autoComplete="off"/>
              </div>)}</div>}
        </div>}
        {additionalWasteControls}
        {includeExtendedSaleWastesData && <SaleWastesAdditionalForm parentName={parentName} /> }
      </Row>
    </div>
  </>;
}